import { render, staticRenderFns } from "./CreditTerm.vue?vue&type=template&id=387e2d74&scoped=true&"
import script from "./CreditTerm.vue?vue&type=script&lang=js&"
export * from "./CreditTerm.vue?vue&type=script&lang=js&"
import style0 from "./CreditTerm.vue?vue&type=style&index=0&id=387e2d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e2d74",
  null
  
)

export default component.exports